/* eslint-disable import/prefer-default-export */
export const BASE_URL = "https://ug.ibs.ke/api";
// export const BASE_URL = 'https://staging.ibs.ke/api';
// export const BASE_URL = "http://localhost:8080/api";
